import { Switch, Group, Text } from "@mantine/core";
import useIsDesktop from "../../../hooks/useIsDesktop";

export const CustomSwitch = ({
  activeLabel,
  inactiveLabel,
  checked,
  ...props
}) => {
  const isDesktop = useIsDesktop();
  const showLabel = activeLabel || inactiveLabel;

  if (!showLabel) {
    return <Switch checked={checked} {...props} />;
  }

  return (
    <Group gap="xs" align="center">
      <Switch checked={checked} {...props} />
      <Text size={isDesktop ? "sm" : "xs"} c={checked ? props.color : "dimmed"}>
        {checked ? activeLabel : inactiveLabel}
      </Text>
    </Group>
  );
};
